import React from 'react';
import { Layout } from '@americanexpress/dls-react';
import { IconWarning } from '@americanexpress/dls-icons';
import { NOT_FOUND_SCREEN } from '../copyText/notFoundScreen';

/**
 * NotFoundScreen – Displayed when a user navigates to an unrecognised route.
 */
function NotFoundScreen() {
  return (
    <Layout variant="card" className="row">
      <div className="col-md-4 col-md-offset-4 text-align-center pad-t">
        <IconWarning
          isFilled={false}
          title={NOT_FOUND_SCREEN.ARIA_ICON_TITLE}
          titleId="not-found-screen-icon"
          size="xl"
          color="critical"
        />
      </div>
      <div className="col-md-4 col-md-offset-4">
        <p className="text-align-center pad-t">{NOT_FOUND_SCREEN.DESCRIPTION}</p>
      </div>
      <div className="col-md-6 col-md-offset-3 margin-b">
        <p className="text-align-center pad-tb">
          {NOT_FOUND_SCREEN.SUPPORT_TEXT}
        </p>
      </div>
    </Layout>
  );
}

NotFoundScreen.propTypes = {};

export default NotFoundScreen;
